import React, { useState, useEffect } from 'react';
import './DevModeCredentialsModal.css';

const DevModeCredentialsModal = ({ open, onSubmit, loading = false, externalError = '' }) => {
  const [apiKey, setApiKey] = useState('');
  const [showApiKey, setShowApiKey] = useState(false);
  const [error, setError] = useState('');

  // Update error when external error changes
  useEffect(() => {
    if (externalError) {
      setError(externalError);
    }
  }, [externalError]);

  const validateApiKey = (value) => {
    if (!value) {
      return 'API Key is required';
    }
    if (value.length < 10) {
      return 'API Key must be at least 10 characters';
    }
    return '';
  };

  const handleApiKeyChange = (e) => {
    const value = e.target.value;
    setApiKey(value);
    setError(validateApiKey(value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const apiKeyError = validateApiKey(apiKey);
    setError(apiKeyError);

    if (!apiKeyError) {
      onSubmit(apiKey);
    }
  };

  const isFormValid = apiKey && !error;

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Dev Mode Configuration</h2>
          <p>Please enter your API key to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="apiKey">API Key</label>
            <div className="input-wrapper">
              <input
                id="apiKey"
                type={showApiKey ? 'text' : 'password'}
                value={apiKey}
                onChange={handleApiKeyChange}
                disabled={loading}
                placeholder="Enter your API key"
                className={error ? 'input-error' : ''}
              />
              <button
                type="button"
                onClick={() => setShowApiKey(!showApiKey)}
                disabled={loading}
                className="toggle-visibility"
                aria-label={showApiKey ? 'Hide API key' : 'Show API key'}
              >
                {showApiKey ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {error && <span className="error-message">{error}</span>}
          </div>

          <button
            type="submit"
            disabled={!isFormValid || loading}
            className="submit-button"
          >
            {loading ? 'Connecting...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DevModeCredentialsModal;
